import { render, staticRenderFns } from "./ForeignContractorRegistrationModalDetails.vue?vue&type=template&id=64a2b4bb&scoped=true&"
import script from "./ForeignContractorRegistrationModalDetails.vue?vue&type=script&lang=ts&"
export * from "./ForeignContractorRegistrationModalDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2b4bb",
  null
  
)

export default component.exports